import { CircularProgress } from "@mui/material";
import { Box, SxProps } from "@mui/system";

const sx: SxProps = {
    marginTop: "spacing",
};

const Loading = () => (
    <Box>
        <CircularProgress size={48} color={"primary"} sx={sx} />
    </Box>
);

export default Loading;
